import fetch from 'isomorphic-fetch';
import { createReducer } from '../utils';

export const FETCH = 'development/FETCH';
export const FETCH_SUCCESS = 'development/FETCH_SUCCESS';
export const FETCH_ERROR = 'development/FETCH_ERROR';
export const RESET_TIMER_SUCCESS = 'development/RESET_TIMER_SUCCESS';
export const STARTED = 'development/STARTED';
export const ENDED = 'development/ENDED';
export const ENDING_UPDATED = 'development/ENDING_UPDATED';

const initialState = {
  data: null,
  fetching: false,
  isError: false,
};

export function fetchDevelopment(hashId) {
  return (dispatch) => {
    dispatch({ type: FETCH });

    var options = { 
      method: 'GET',
    };

    return fetch(`/api/development/${hashId}`, options)
      .then(response => response.json())
      .then(payload => dispatch({
        type: FETCH_SUCCESS,
        payload,
      }))
      .catch(error => dispatch({
        type: FETCH_ERROR,
        error
      }));
  };
};

export function resetTimer() {
  return (dispatch) => {
    const now = new Date();
    const offersClose = new Date(now.getTime() + 45000);
    dispatch({ type: RESET_TIMER_SUCCESS, payload: { offersClose } });
  };
};

export function propertyStarted(payload) {
  return (dispatch, getState) => {
    dispatch({ type: STARTED, payload });
  }
};

export function propertyEnded(payload) {
  return (dispatch, getState) => {
    dispatch({ type: ENDED, payload });
  }
};

export function propertyEndingUpdated(hashId, payload) {
  return (dispatch, getState) => {
    dispatch({ type: ENDING_UPDATED, payload });
  }
};

export default createReducer(initialState, {
  [FETCH]: state => ({
    ...state,
    fetching: true,
    isError: false,
  }),
  [FETCH_SUCCESS]: (state, payload) => ({
    ...state,
    data: payload,
    fetching: false,
    isError: false,
  }),
  [RESET_TIMER_SUCCESS]: (state, payload) => {
    const properties = state.data.properties.map(property => Object.assign({}, property, { offersClose: payload.offersClose }));
    return {
      ...state,
      data: {
        ...state.data,
        properties,
      },
    };
  },
  [STARTED]: (state, payload) => {
    const properties = state.data.properties.map(property => {
      const { starting, ending, offerStatus } = payload;
      return payload.property === property.hashId ?
        Object.assign({}, property, {
          starting,
          ending,
          offerStatus,
        }) :
        property;
    });
    return {
      ...state,
      data: {
        ...state.data,
        properties,
      },
    };
  },
  [ENDED]: (state, payload) => {
    const properties = state.data.properties.map(property => {
      const { starting, ending, offerStatus } = payload;
      return payload.property === property.hashId ?
        Object.assign({}, property, {
          starting,
          ending,
          offerStatus,
        }) :
        property;
    });
    return {
      ...state,
      data: {
        ...state.data,
        properties,
      },
    };
  },
  [ENDING_UPDATED]: (state, payload) => {
    const properties = state.data.properties.map(property => {
      const { ending } = payload;
      return payload.property === property.hashId ?
        Object.assign({}, property, {
          ending,
        }) :
        property;
    });
    return {
      ...state,
      data: {
        ...state.data,
        properties,
      },
    };
  },
});



// WEBPACK FOOTER //
// ./src/redux/development.js